import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game2Store')
@observer
export default class GameStep2 extends Component {

    chooseSituation(situation) {
        this.props.Game2Store.setSituation(situation);
    }

    render() {

        const {
            situation
        } = this.props.Game2Store;

        return (
            <div className="step-2">
                <h1>Situation Introduction</h1>
                <div className="situations">
                    <button className={situation === 1 ?  " selected": ""}
                            onClick={this.chooseSituation.bind(this, 1)}>
                        <h1>Salary Raise</h1>
                        <p className="p-situation">Employer and employee have a meeting scheduled to talk about the employee’s salary.</p>
                        <p className="p-situation">
                            Green Team – You are the employer. You like your employee’s work very much, but you cannot offer more than a 5 percent raise.
                            <br/><br/>
                            Red Team – You really like to work for your employer, but you think you should be paid at least 10 percent more than you are now.
                        </p>
                    </button>

                    <button className={situation === 2 ?  "situation selected": "situation"}
                            onClick={this.chooseSituation.bind(this, 2)}>
                        <h1>Traveling With Your Best Friend</h1>
                        <p className="p-situation">You and your best friend are arranging a trip to the U.S. on your vacation, but you can only spend 10 days there.</p>
                        <p className="p-situation">
                            Green Team – You really want to travel with your friend to the U.S. You would like to spend 10 days in New York.
                            <br/><br/>
                            Red Team – You really want to travel with your friend to the U.S. You would like to spend 10 days in Florida.
                        </p>
                    </button>
                </div>
            </div>
        )
    }

};



// WEBPACK FOOTER //
// ./src/containers/Game2/Game2Step3.js